<div class="section-page">
  <div class="container">
    <div class="row">
      <div class="col text-center">
        <h2>{{ section.title }}</h2>
        <p class="sub-title">{{ section.subtitle }}</p>
      </div>
    </div>
    <app-category-list
      [categoryList]="section.categoryList"
    ></app-category-list>
  </div>
</div>
